(() => {
  if (window.favenueBuyNowInitialized) return;
  window.favenueBuyNowInitialized = true;

  const setError = (form, message) => {
    const productForm = form.closest('.product-form');
    const errorMessage = productForm?.querySelector('.product-form__error-message');
    if (!errorMessage) return;

    errorMessage.textContent = message || '';
    errorMessage.toggleAttribute('hidden', !message);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-favenue-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form || (form.reportValidity && !form.reportValidity())) return;

    setError(form, '');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('btn--loading');

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to proceed to checkout.');
      }

      window.location.assign(`${window.Shopify.routes.root}checkout`);
    } catch (error) {
      setError(form, error.message || 'Unable to proceed to checkout.');
      button.removeAttribute('aria-disabled');
      button.classList.remove('btn--loading');
    }
  });
})();
